export const umibuilderTags = ['keyFields', 'tempGroupData']
